import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default: localStorage if web, AsyncStorage if react-native
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import rootReducer, { reducers } from './reducers';

import Raven from './sentry';

/**
 * redux-persist setup
 */
const persistConfig = {
  key: 'root',
  blacklist: [
    'notifications',
    'serviceStatus',
    ...Object.keys(reducers).filter(r => r.endsWith('Form')),
    'rrSignupForms',
    'cancelations',
  ],
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const history = createHistory();


const middleware = [
  applyMiddleware(thunk),
  applyMiddleware(routerMiddleware(history)),
];


if (Raven) {
  // eslint-disable-next-line global-require
  const createRavenMiddleware = require('raven-for-redux');
  middleware.push(applyMiddleware(createRavenMiddleware(Raven)));
}


/* istanbul ignore if */
if (process.env.NODE_ENV === 'development') {
  middleware.push(applyMiddleware(createLogger({ collapsed: true })));
}

// creates the Redux store
const store = createStore(
  persistedReducer,
  compose(...middleware),
);


export const persistor = persistStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/store.js